import React, {forwardRef, useImperativeHandle, useRef} from 'react';
import PropTypes from 'prop-types';
import {Button, Descriptions} from 'antd';
import classNames from 'classnames';

import {EditOutlined} from '@/icons';
import LocalApiWxmpFormModal from './LocalApiWxmpFormModal';
import {SecurityTextView} from '@/component';

import styles from '../styles.module.less';

const LocalApiWxmpViewer = forwardRef(({clientAppId, link, reload}, ref) => {
    const LocalApiWxmpFormModalRef = useRef();
    console.log('LocalApiWxmpFormModalRef', LocalApiWxmpFormModalRef);

    const jsonData = link.jsonData || null;
    console.log('link data', link);
    const {appId, appSecret, descript} = JSON.parse(jsonData) || {};
    const labelStyle = {width: 100, fontWeight: 'bold'};

    function showEditModal() {
        LocalApiWxmpFormModalRef.current.showModal();
    }

    useImperativeHandle(ref, () => ({
        showEditModal,
    }));

    return (
        <>
            <Descriptions
                column={1}
                title={
                    <span>
                        公众号配置
                        <Button icon={<EditOutlined />} type="link" onClick={showEditModal} />
                    </span>
                }
                className={classNames(styles.meta, styles.apiInfo)}
                style={{marginBottom: 24}}
            >
                <Descriptions.Item label="公众号标题" labelStyle={labelStyle}>
                    {descript || '未定义'}
                </Descriptions.Item>
                <Descriptions.Item label="App Id" labelStyle={labelStyle}>
                    {appId || '未定义'}
                </Descriptions.Item>
                <Descriptions.Item label="App Secret" labelStyle={labelStyle}>
                    {appSecret ? <SecurityTextView text={appSecret} /> : '未定义'}
                </Descriptions.Item>
            </Descriptions>

            <LocalApiWxmpFormModal
                ref={LocalApiWxmpFormModalRef}
                clientAppId={clientAppId}
                link={link}
                reload={reload}
            />
        </>
    );
});

LocalApiWxmpViewer.displayName = 'LocalApiWxmpView';

LocalApiWxmpViewer.propTypes = {
    clientAppId: PropTypes.string.isRequired,
    link: PropTypes.shape({
        jsonData: PropTypes.string,
    }).isRequired,
    reload: PropTypes.func.isRequired,
};

export default LocalApiWxmpViewer;
